import { createFileRoute } from '@tanstack/react-router'
import TenantConfig from '@/components/settings-route/tenant/config.jsx'

export const Route = createFileRoute('/_auth/settings/tenant/config/$tenantId')(
  {
    component: () => {
      const { tenantId } = Route.useParams()
      return <TenantConfig tenantId={tenantId} />
    },
  },
)
